import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import * as S from './DesktopHeaderNewAdBtn.styles';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { getNewAdPageHref } from '@/utils/helpers';

interface DesktopHeaderNewAdBtnProps {
  onClick: () => void;
}

export const DesktopHeaderNewAdBtn = ({
  onClick,
}: DesktopHeaderNewAdBtnProps) => {
  const { t } = useTranslation();
  const { asPath } = useRouter();

  return (
    <S.DesktopNewAdBtnBox
      id="new_ad_link"
      dataTestId={CommonTestIds.desktopHeader.newAdButton}
      href={getNewAdPageHref(asPath)}
      onClick={onClick}
    >
      <S.DesktopNewAdBtn>
        <IconBox
          $filename="new-ad.svg"
          $width={17}
          $height={17}
          $iconHeight={17}
          $iconWidth={17}
        />
        <span>{t('common.new_ad')}</span>
      </S.DesktopNewAdBtn>
    </S.DesktopNewAdBtnBox>
  );
};
